import {takeLatest} from 'redux-saga/effects';
import * as saga from './saga';
import * as ACTION from './constants';

export default function*() {
    yield takeLatest(ACTION.FETCH_SHIPPING_USER.REQUEST, saga.getShippingUsers);
    yield takeLatest(ACTION.FETCH_SHIPPING_USER_SUGGEST.REQUEST, saga.getShippingUsersSuggest);
}
